import { ActorRepository } from '../data/actor-repository';
import { ConnectorDashboardRequest, ConnectorDashboardResponse } from '../types/api-types';

export class GetOperatorMachineListUseCase {
  constructor(private actorRepository: ActorRepository) {}

  async execute(operatorId: string, params?: ConnectorDashboardRequest): Promise<ConnectorDashboardResponse> {
    return await this.actorRepository.getConnectors(operatorId, params);
  }
}
